<template>
  <LibraryListItem>
    <a
      class="w-100 h-100 d-flex justify-center align-center"
      :href="`/app/view/${template.id}`"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="template info"
      @click.stop
    >
      <DocumentScoreLink :id="template.id" :score="template.score || 0" />
    </a>
    <div class="name-container">
      <h5>
        {{ template.title }}
      </h5>
      <div v-if="template.is_default">
        <v-badge
          color="success"
          content="Default"
          inline
        />
      </div>
    </div>
    <div class="created-by">
      <p>{{ template.created_by || '' }}</p>
    </div>
    <div class="created-date">
      <p>{{ template.created_at ? dateFormat(template.created_at) : '' }}</p>
    </div>
    <div class="last-edited">
      <p>{{ template.last_edited ? dateFormat(template.last_edited) : '' }}</p>
    </div>
    <div class="status" @click.stop>
      <DpplToggleButton
        :model-value="!template.is_hidden"
        :label="template.is_hidden ? 'Hidden' : 'Visible'"
        class="d-flex h-100 w-100 toggle"
        @update:model-value="emits('toggleUpdate', ({ id: template.id, isHidden: template.is_hidden }))"
      />
    </div>
  </LibraryListItem>
</template>

<script setup>
import LibraryListItem from '@/components/shared/LibraryListItem.vue';
import DpplToggleButton from '@/components/datapeople/DpplToggleButton.vue';
import { format } from 'date-fns';
import DocumentScoreLink from '@/components/shared/DocumentScoreLink.vue';

defineProps({
  template: {
    type: Object,
    required: true,
  },
});

const emits = defineEmits(['toggleUpdate']);

const dateFormat = (dateStr) => {
  const seconds = parseInt(dateStr, 10);
  const date = new Date(seconds * 1000);

  return format(date, 'MM/dd/yyyy');
};
</script>

<style lang="less" scoped>
.name-container {
  height: 100%;
  width: 100%;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;

  h5 {
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: @text-darkest;
  }
}

.toggle:deep(.v-label) {
  max-width: initial;
  font-size: 14px;
}

.created-by,
.created-date,
.last-edited {
  max-width: 100%;

  p {
    font-size: 13px;
    font-weight: 500;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}

:deep(label) {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
